import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aa2a7f28")

_pushScopeId("data-v-aa2a7f28")
const _hoisted_1 = { class: "query-input" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_el_date_picker, _mergeProps({
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _ctx.modelValueChange,
      shortcuts: _ctx.shortcuts,
      size: "small",
      class: { empty: _ctx.isEmpty }
    }, _ctx.$attrs, {
      ref: "dataPicker",
      "default-value": _ctx.defaultDate
    }), null, 16, ["modelValue", "onUpdate:modelValue", "shortcuts", "class", "default-value"]),
    _createVNode("label", {
      for: _ctx.inputId,
      onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectDate && _ctx.selectDate(...args)), ["prevent"]))
    }, _toDisplayString(_ctx.labelName), 9, ["for"])
  ]))
})